import { Component, OnInit } from '@angular/core';
import { AppSettingService } from '../../services/app-setting.service';
import { FullSpinnerService } from '../../services/full-spinner.service';
import { AppSetting } from '../../models/AppSetting';
import { StorageService } from '../../services/storage.service';
import { CommonModule } from '@angular/common';
import { HasPermissionDirective } from '../../utils/has-permission.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppConstants } from '../../utils/AppConstants';
import { AlertService } from '../shared/alert/alert.service';
import { AppEnums } from '../../models/AppEnums';

@Component({
  selector: 'app-app-setting',
  standalone: true,
  imports: [CommonModule, HasPermissionDirective, FormsModule, ReactiveFormsModule],
  templateUrl: './app-setting.component.html',
  styleUrl: './app-setting.component.scss'
})
export class AppSettingComponent implements OnInit {

  appSettings: AppSetting[] = [];
  groupedAppSettings: { component: string, settings: AppSetting[] }[] = [];
  organizationId?: number;

  appSettingsForm!: FormGroup;

  constructor(
    private appSettingService: AppSettingService, 
    private storageService: StorageService, 
    private alertService: AlertService, 
    private formBuilder: FormBuilder, 
    private fullSpinnerService: FullSpinnerService) {
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.organizationId = this.storageService.getLoggedUser().organizationId;
    this.organizationId = this.organizationId == null || this.organizationId === undefined ? 0 : this.organizationId;
    this.find();
  }
  find() {
    this.fullSpinnerService.spinner('');
    this.appSettingService.find(this.organizationId!).subscribe({
      next: (res) => {
        this.appSettings = res;
        this.groupedAppSettings = this.groupByComponent(res);
        let objLists: any = {};
        res.forEach((setting, _) => {
          if (setting.required && setting.validationRegex)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.required, Validators.pattern(setting.validationRegex)]];

          else if (setting.required)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.required]];
          else if (setting.validationRegex)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.pattern(setting.validationRegex)]];
          else
            objLists[setting.keyId!] = [this.computeSettingValue(setting), []];

        });
        this.appSettingsForm = this.formBuilder.group(objLists);

      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }
  private groupByComponent(appSettings: AppSetting[]): { component: string, settings: AppSetting[] }[] {
    const groups: { component: string, settings: AppSetting[] }[] = [];
    appSettings.forEach((setting) => {
      const component = setting.component || 'Generale';
      let group = groups.find(g => g.component === component);
      if (!group) {
        group = { component, settings: [] };
        groups.push(group);
      }
      group.settings.push(setting);
    });
    return groups;
  }

  computeComponentLabel(component: string): string {
    return AppEnums.appSettingComponentTypes.find(c => c.id === component)?.description || component;
  }

  private computeSettingValue(appSetting: AppSetting) {
    if (appSetting.type === "boolean") {
      if (appSetting.value && appSetting.value === "true")
        return true;
      else if (appSetting.value && appSetting.value === "false")
        return false;

      else return false;
    }
    return appSetting.value;
  }

  onSave() {
    if (this.appSettingsForm.valid) {
      this.fullSpinnerService.spinner('');
      this.appSettings.forEach((setting) => {
        setting.value = this.appSettingsForm.controls[setting.keyId!].value;
      });

      this.appSettingService.save(this.organizationId!, this.appSettings).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.find();
        }, complete: () => {
        }
        , error: () => {
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}
